// src/state/useFirebaseAuth/FirebaseApp.ts (o donde lo tengas)
import firebase from 'firebase';
require('firebase/firestore');
require('firebase/database');
var jwt = require('jsonwebtoken');

if (firebase.apps.length) {
  firebase.app();
} else {
  firebase.initializeApp({
    apiKey: "AIzaSyCaPei14v0aK2d2eHI52edQprnESNYTg6c",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: 'servicehub-crm-web',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_MESSAGING_APP_ID,
    measurementId: 'G-4ZV0C6QKFV',
  });
}

export default function FirebaseApp() {
  const tokenDataCrm = async (URLRoomName: any) => {
    try {
      // Step 1 — wait for SDK to restore any persisted session from localStorage.
      // onAuthStateChanged fires once with the initial auth state (user or null).
      const initialUser = await new Promise<any>((resolve) => {
        const unsub = firebase.auth().onAuthStateChanged((user) => {
          unsub();
          resolve(user);
        });
      });

      // Step 2 — if no cached session (fresh browser / localStorage cleared),
      // sign in now before touching Firestore. This removes the dependency on
      // Effect #2 (auth()) in App.tsx and eliminates the race condition entirely.
      if (!initialUser) {
        const mail: any = 'production@servicetechnologies.biz';
        const pass: any = '5DYjdz634wzCozHmcbTUyy';
        await firebase.auth().signInWithEmailAndPassword(mail, pass);
      }

      const doc = await firebase
        .firestore()
        .collection('servicehubcrmvideocallFb')
        .doc(URLRoomName)
        .get();

      if (doc.exists) {
        onSnapshot(URLRoomName);
        const data = doc.data();
        const decode = jwt.decode(doc.data()?.token);
        return { data, decode };
      } else {
        return false;
      }
    } catch (err) {
      console.error('[tokenDataCrm] Firestore error:', err);
      return false;
    }
  };

  const onSnapshot = async (URLRoomName: any) => {
    firebase
      .firestore()
      .collection('servicehubcrmvideocallFb')
      .doc(URLRoomName)
      .onSnapshot(
        docSnapshot => {
          const data = docSnapshot.data();
          if (data?.isCanceled) {
            window.location.assign(
              `https://${data.host}/#/payment-expire/${data.company_id}`
            );
          }
        },
        err => {
          console.log(`Encountered error: ${err}`);
        }
      );
  };

  const update = async (URLRoomName: any, data: {}) => {
    await firebase
      .firestore()
      .collection('servicehubcrmvideocallFb')
      .doc(URLRoomName)
      .update(data);
  };

  // AHORA: solo 2 parámetros, el uid se obtiene del usuario autenticado
  const disconnectRoom = async (room: string, data: any) => {
    let currentUser = firebase.auth().currentUser;

    if (!currentUser) {
      const mail: any = 'production@servicetechnologies.biz';
      const pass: any = '5DYjdz634wzCozHmcbTUyy';
      const userCredential = await firebase
        .auth()
        .signInWithEmailAndPassword(mail, pass);
      currentUser = userCredential.user;
    }

    const uid = currentUser!.uid;

    return firebase.database().ref(`disconnected/${uid}/${room}`).set(data);
  };

  const auth = async () => {
    const mail: any = 'production@servicetechnologies.biz';
    const pass: any = '5DYjdz634wzCozHmcbTUyy';
    const userCredential = await firebase
      .auth()
      .signInWithEmailAndPassword(mail, pass);
    return userCredential?.user?.uid;
  };

  return { firebase, tokenDataCrm, update, disconnectRoom, auth };
}
